import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors } from "@styles";

export const price = {
  text: css`
    color: ${colors.dark};
  `,
  dark: css`
    color: ${colors.dark};
  `,
  blue: css`
    color: ${colors.blue.base};
    font-weight: ${typography.weightSemiBold};
  `,
  grey: css`
    color: ${colors.grey.darkFamily.dark};
  `,
};
